export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/apps/frontend/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/contractors',
    /* internal name: '/contractors' */
    /* no component */
    children: [
      {
        path: '',
        name: '/contractors/',
        component: () => import('/app/apps/frontend/src/pages/contractors/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/contractors/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/contractors/[id]/',
            component: () => import('/app/apps/frontend/src/pages/contractors/[id]/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/app/apps/frontend/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/projects',
    /* internal name: '/projects' */
    /* no component */
    children: [
      {
        path: '',
        name: '/projects/',
        component: () => import('/app/apps/frontend/src/pages/projects/index.vue'),
        /* no children */
      },
      {
        path: ':code',
        /* internal name: '/projects/[code]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/projects/[code]/',
            component: () => import('/app/apps/frontend/src/pages/projects/[code]/index.vue'),
            /* no children */
          },
          {
            path: 'progress',
            /* internal name: '/projects/[code]/progress' */
            /* no component */
            children: [
              {
                path: 'import',
                name: '/projects/[code]/progress/import',
                component: () => import('/app/apps/frontend/src/pages/projects/[code]/progress/import.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'create',
        name: '/projects/create',
        component: () => import('/app/apps/frontend/src/pages/projects/create.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/app/apps/frontend/src/pages/settings.vue'),
    children: [
      {
        path: '',
        name: '/settings/',
        component: () => import('/app/apps/frontend/src/pages/settings/index.vue'),
        /* no children */
      },
      {
        path: 'classifiers',
        name: '/settings/classifiers',
        component: () => import('/app/apps/frontend/src/pages/settings/classifiers.vue'),
        /* no children */
      },
      {
        path: 'districts',
        name: '/settings/districts',
        component: () => import('/app/apps/frontend/src/pages/settings/districts.vue'),
        /* no children */
      },
      {
        path: 'financing-source-types',
        name: '/settings/financing-source-types',
        component: () => import('/app/apps/frontend/src/pages/settings/financing-source-types.vue'),
        /* no children */
      },
      {
        path: 'general',
        name: '/settings/general',
        component: () => import('/app/apps/frontend/src/pages/settings/general.vue'),
        /* no children */
      },
      {
        path: 'positions',
        name: '/settings/positions',
        component: () => import('/app/apps/frontend/src/pages/settings/positions.vue'),
        /* no children */
      },
      {
        path: 'software-categories',
        name: '/settings/software-categories',
        component: () => import('/app/apps/frontend/src/pages/settings/software-categories.vue'),
        /* no children */
      },
      {
        path: 'tags',
        name: '/settings/tags',
        component: () => import('/app/apps/frontend/src/pages/settings/tags.vue'),
        /* no children */
      },
      {
        path: 'users',
        name: '/settings/users',
        component: () => import('/app/apps/frontend/src/pages/settings/users.vue'),
        /* no children */
      },
      {
        path: 'work-execution-types',
        name: '/settings/work-execution-types',
        component: () => import('/app/apps/frontend/src/pages/settings/work-execution-types.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/supervisors',
    /* internal name: '/supervisors' */
    /* no component */
    children: [
      {
        path: '',
        name: '/supervisors/',
        component: () => import('/app/apps/frontend/src/pages/supervisors/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

